import React, { useCallback, useContext, useEffect, useState } from 'react';
import ReportsContext from '../../../../contexts/ReportsContext';

const usePermittedReports = () => {
  const { allReports } = useContext(ReportsContext);
  const getReports = useCallback(() => {
    return allReports.filter((d) => !d.isHidden);
  }, [allReports]);

  const [reports, setReports] = useState<ReportType[]>(getReports);
  useEffect(() => {
    setReports(getReports());
  }, [getReports]);

  return reports;
};

const useReportOptions = ({
  selectedReport,
  setSelectedReport,
  setTitle,
}: {
  selectedReport: ReportType | undefined;
  setSelectedReport: React.Dispatch<
    React.SetStateAction<ReportType | undefined>
  >;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const reports = usePermittedReports();

  const buildOptions = useCallback((): DropdownOption[] => {
    return reports.map((d) => ({
      key: d.id,
      label: d.name,
      isSelected: !!selectedReport && d.id === selectedReport.id,
      onSelected: () => {
        setSelectedReport(d);
        setTitle(d.name);
      },
    }));
  }, [reports, selectedReport, setSelectedReport, setTitle]);
  const [options, setOptions] = useState<DropdownOption[]>(buildOptions());
  useEffect(() => {
    setOptions(buildOptions());
  }, [buildOptions]);

  return options;
};

export default useReportOptions;
